module.exports = __webpack_public_path__ + "img/Jitao_Sang@2x.a734859f.png";